import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AngularDeviceInformationService } from 'angular-device-information';
import { LoadingService } from '../services/loading/loading.service';

@Component({
  selector: 'app-redirect',
  templateUrl: './redirect.component.html',
  styleUrls: ['./redirect.component.scss']
})
export class RedirectComponent implements OnInit {

  constructor(private _loading: LoadingService, private router: Router,private route: ActivatedRoute, private deviceInformationService: AngularDeviceInformationService) { }

  ngOnInit(): void {
    this._loading.showLoading();
    var type = this.route.snapshot.paramMap.get("type");
    var os = this.deviceInformationService.getDeviceInfo().os;
    if(os === 'Android'){
      if(type == 'driver')
        window.location.href = 'https://play.google.com/store/apps/details?id=com.deliverypal';
      else
        window.location.href = 'https://play.google.com/store/apps/details?id=com.driverbooking&gl=GB';
    }
    else if(os === 'iOS'){
      if(type == 'driver')
        window.location.href = 'https://apps.apple.com/gb/app/deliverypal-driver/id6448951014';
      else
        window.location.href = 'https://apps.apple.com/gb/app/deliverypal-partner/id6471603628';
    }
    else{
      this.router.navigate(['/']);
    }
  }

}
